export default {
  routes: [
    {
      name: 'compensations',
      path: '/directory/compensation',
      component: () => import('./views/TheCompensations.vue'),

    },

    {
      name: 'compensation',
      path: '/directory/compensation/:uuid',
      component: () => import('./views/TheCompensation.vue'),
    },
  ]
}
